export const DASHBOARD_TABS = [
  "Executive Overview",
  "Social Performance",
  "Platform Performance",
  "Sentiment",
  "Flavour Insights",
  "Topics & Keywords",
  "Reviews",
  "Alerts & Trends",
  "Market Context",
  "Detailed Data",
];

export const FILTER_FIELDS = {
  brand: { label: "Brand", multi: true },
  period: { label: "Date / Period", multi: false },
  platform: { label: "Platform", multi: true },
  source: { label: "Source", multi: true },
  sentiment: { label: "Sentiment", multi: true },
  topicKeyword: { label: "Topic / Keyword", multi: true },
  flavour: { label: "Flavour", multi: true },
  reviewDimensionType: { label: "Review Dimension Type", multi: false },
  reviewDimensionValue: { label: "Review Dimension Value", multi: true },
  alertSeverity: { label: "Alert Severity", multi: true },
  alertType: { label: "Alert Type", multi: true },
  marketCategory: { label: "Market Category", multi: true },
  marketMetric: { label: "Market Metric", multi: false },
};

export const DEFAULT_FILTER_STATE = {
  brand: [],
  period: "last_90_days",
  platform: [],
  source: [],
  sentiment: [],
  topicKeyword: [],
  flavour: [],
  reviewDimensionType: "",
  reviewDimensionValue: [],
  alertSeverity: [],
  alertType: [],
  marketCategory: [],
  marketMetric: "",
  startDate: null,
  endDate: null,
};

export const DIMENSION_OPTIONS = [
  "Platform",
  "Brand",
  "Period",
  "Source",
  "Flavour",
  "Topic",
  "Sentiment",
  "Review Dimension",
  "Market Category",
  "Alert Type",
  "Severity",
];

export const METRIC_OPTIONS = [
  "Mentions",
  "Impressions",
  "Engagements",
  "Reactions",
  "Comments",
  "Shares",
  "Video Views",
  "Followers",
  "Saves",
  "Link Clicks",
  "Engagement Rate",
  "Sentiment",
  "Growth %",
];

export const CHART_TYPES = ["bar", "line", "donut", "table"];

export const SEVERITY_ORDER = ["critical", "high", "medium", "low"];
